import script from "./InnCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./InnCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./InnCheckbox.vue?vue&type=style&index=0&id=188f87df&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-188f87df"]])

export default __exports__